import { render, staticRenderFns } from "./ConsultingItem.vue?vue&type=template&id=67aa878a&scoped=true&"
import script from "./ConsultingItem.vue?vue&type=script&lang=js&"
export * from "./ConsultingItem.vue?vue&type=script&lang=js&"
import style0 from "./ConsultingItem.vue?vue&type=style&index=0&id=67aa878a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa878a",
  null
  
)

export default component.exports